import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AppDispatch } from '../../app/store';
import { Dashboard } from './Dashboard';
import { loadReportContent, selectLoading, selectReport } from './dashboardSlice';
import { useCodeScanStatus, useLastReportRedirect, useReportStatus } from './hooks';

export const DashboardContainer: React.FC = () => {
  const { code } = useParams();
  const dispatch: AppDispatch = useAppDispatch();
  const report = useAppSelector(selectReport);
  const isLoading = useAppSelector(selectLoading);
  const [isReady, setIsReady] = useState<boolean>(false);

  useLastReportRedirect(code);
  useReportStatus(code, () => {
    setIsReady(true);
    dispatch(loadReportContent(code as string));
  });
  useCodeScanStatus(isReady ? code : undefined, () => {
    dispatch(loadReportContent(code as string));
  });

  return (
    <Dashboard isLoading={isLoading} report={report} />
  );
};
